import React from 'react';

const WellnessPage = () => (
  <div>
    <div className="banner" style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
      <img src="/images/terace.jpg" alt="Terrace" style={{ maxWidth: '800px', width: '100%', height: 'auto', borderRadius: '8px' }} />
    </div>
    <div className="description" style={{ padding: '2rem' }}>
      <h2>Wellness & Social Spaces</h2>
      <p>
        Luxury Living. Wellness. Community.
        <br />
        an exclusive apartment residence where elegance, wellness, and social living come together. Designed for discerning residents, this premium development offers a lifestyle defined by comfort and sophistication.
      </p>
      <p>
        Residents enjoy state-of-the-art indoor gym facilities, a dedicated aerobics and wellness studio, and a beautifully designed rooftop terrace ideal for private gatherings, celebrations, and social events with city views.
      </p>
      <ul>
        <li>Fully equipped residents-only gym</li>
        <li>Dedicated aerobics & wellness studio</li>
        <li>Elegant terrace for gatherings & private events</li>
      </ul>
      <p>A home that elevates your lifestyle.</p>
    </div>
  </div>
);

export default WellnessPage;
